// Lift the folded paper off its stack, then let the canvas take it: held
// up, falling open, brought up to read. Where the window is as wide as the
// broadsheet, the actual DOM page takes over where the manifesto's page
// has its newspaper: under the header, centred.
export default async function unfoldNewspaper(paper, backdrop, scale, header) {
  const object = paper.querySelector(".mf-object");
  const preparing = import("./newspaperTurn").then(module => module.default(paper, scale, header));
  paper.dataset.open = "lift";
  backdrop.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 500, fill: "forwards", easing: "ease" });
  const lift = object.animate([{ transform: getComputedStyle(object).transform }, { transform: "translateY(-10px)" }], { duration: 200, fill: "forwards", easing: "ease-out" });
  const [turn] = await Promise.all([preparing, lift.finished]);
  let dissolving = false;
  try {
    await turn.play();
    if (!paper.isConnected) return;
    if (!turn.fits) {
      // The page lays itself out for this window, not as the broadsheet:
      // the open paper dissolves into it once it is there.
      turn.dissolve();
      dissolving = true;
      return;
    }
    const box = paper.getBoundingClientRect();
    const width = parseFloat(paper.style.getPropertyValue("--w"));
    const left = ((document.documentElement.clientWidth || window.innerWidth) - width) / 2;
    paper.style.transform = `translate(${left - box.left}px, ${header - box.top}px) scale(${1 / scale})`;
    object.style.transform = "none";
    lift.cancel();
    paper.dataset.open = "grow";
    // Paint the flat DOM before removing the canvas, keeping the page
    // available throughout the route's handoff.
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  } finally {
    if (!dissolving) turn.dispose();
  }
}
